(function () {
  'use strict';

  var root, body, foot, titleEl;
  var cfg = {};
  var busy = false;

  function cfgGet() {
    var el = document.querySelector('[data-mcart]');
    if (!el) return null;
    root = el;
    try { cfg = JSON.parse(el.getAttribute('data-mcart-config') || '{}'); } catch (e) { cfg = {}; }
    body = el.querySelector('.mcart__body');
    foot = el.querySelector('.mcart__foot');
    titleEl = el.querySelector('.mcart__count');
    return el;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function group(num, thousands, decimal, dec) {
    var parts = num.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function money(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    var v = (cents || 0) / 100;
    var out;
    switch (m[1]) {
      case 'amount_no_decimals': out = group(v, ',', '', 0); break;
      case 'amount_with_comma_separator': out = group(v, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = group(v, '.', '', 0); break;
      case 'amount_with_space_separator': out = group(v, ' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': out = group(v, ' ', '', 0); break;
      case 'amount_with_apostrophe_separator': out = group(v, "'", '.', 2); break;
      default: out = group(v, ',', '.', 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function thumb(url, w) {
    if (!url) return '';
    return url.replace(/(\.(png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$3');
  }

  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function open() {
    if (!root) return;
    root.classList.add('is-open');
    document.body.classList.add('mcart-locked');
    requestAnimationFrame(function () { root.classList.add('is-in'); });
    root.setAttribute('aria-hidden', 'false');
    var c = root.querySelector('.mcart__close');
    if (c) c.focus();
    refresh();
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-in');
    root.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      root.classList.remove('is-open');
      document.body.classList.remove('mcart-locked');
    }, 420);
  }

  function skeleton() {
    if (body) body.innerHTML = '<div class="mcart__skel"><div class="mcart__skelrow"></div><div class="mcart__skelrow"></div></div>';
  }

  function refresh() {
    return getJSON('/cart.js').then(render).catch(function () {});
  }

  function render(cart) {
    if (!body || !cart) return;

    if (titleEl) titleEl.textContent = '(' + cart.item_count + ')';

    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<div class="mcart__empty">' +
        '<svg class="mcart__emptyicon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p class="mcart__emptytitle">' + esc(cfg.emptyTitle) + '</p>' +
        '<p class="mcart__emptytext">' + esc(cfg.emptyText) + '</p>' +
        '<a class="mcart__emptybtn" href="' + esc(cfg.emptyUrl || '/collections/all') + '">' + esc(cfg.emptyBtn) + '</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;

    var html = '<ul class="mcart__items">';
    cart.items.forEach(function (it) {
      var opts = '';
      if (!it.product_has_only_default_variant && it.options_with_values) {
        opts = it.options_with_values.map(function (o) {
          return esc(o.name) + ': <strong>' + esc(o.value) + '</strong>';
        }).join('<br>');
      }
      var eyebrow = it.product_type || it.vendor || '';
      var priceHtml = money(it.final_line_price);
      if (it.original_line_price > it.final_line_price) {
        priceHtml = '<s>' + money(it.original_line_price) + '</s>' + priceHtml;
      }

      html +=
        '<li class="mcart__item" data-key="' + esc(it.key) + '">' +
        '<a class="mcart__thumb" href="' + esc(it.url) + '">' +
        (it.image ? '<img src="' + esc(thumb(it.image, 240)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="mcart__info">' +
        (eyebrow ? '<p class="mcart__vendor">' + esc(eyebrow) + '</p>' : '') +
        '<a class="mcart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<p class="mcart__price">' + priceHtml + '</p>' +
        (opts ? '<p class="mcart__opts">' + opts + '</p>' : '') +
        '<div class="mcart__qty">' +
        '<button type="button" class="mcart__qbtn" data-act="dec" aria-label="Quitar uno">' +
        (it.quantity > 1
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>') +
        '</button>' +
        '<span class="mcart__qval">' + it.quantity + '</span>' +
        '<button type="button" class="mcart__qbtn" data-act="inc" aria-label="Agregar uno">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</li>';
    });
    html += '</ul>';

    if (cfg.showRecs) html += '<div class="mcart__recs" data-mcart-recs hidden></div>';

    body.innerHTML = html;

    var sub = root.querySelector('.mcart__subtotal');
    if (sub) sub.textContent = money(cart.total_price);
    var btnPrice = root.querySelector('.mcart__btnprice');
    if (btnPrice) btnPrice.textContent = money(cart.total_price);

    if (cfg.showRecs && cart.items.length) loadRecs(cart.items[0].product_id, cart);
  }

  function loadRecs(productId, cart) {
    var host = body.querySelector('[data-mcart-recs]');
    if (!host) return;
    var limit = cfg.recsLimit || 6;
    getJSON('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (data) {
        var inCart = {};
        (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
        var list = (data.products || []).filter(function (p) { return !inCart[p.id]; });
        if (!list.length) return;

        var h = '<p class="mcart__recshead">' + esc(cfg.recsTitle) + '</p><div class="mcart__track">';
        list.forEach(function (p) {
          var v = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) { v = p.variants[i]; break; }
          }
          var img = p.featured_image || (p.images && p.images[0]) || '';
          h +=
            '<div class="mcart__rec">' +
            '<a class="mcart__recimg" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(thumb(img, 300)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<a class="mcart__recname" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<p class="mcart__recprice">' + money(p.price) + '</p>' +
            (v
              ? '<button type="button" class="mcart__recadd" data-vid="' + v.id + '">' + esc(cfg.recsAdd) + '</button>'
              : '<button type="button" class="mcart__recadd" disabled>' + esc(cfg.recsSold) + '</button>') +
            '</div>';
        });
        h += '</div>';
        host.innerHTML = h;
        host.hidden = false;
      })
      .catch(function () {});
  }

  function change(key, qty, li) {
    if (busy) return;
    busy = true;
    if (li) li.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { busy = false; render(cart); syncBubbles(cart); })
      .catch(function () { busy = false; if (li) li.classList.remove('is-busy'); });
  }

  function addVariant(id, btn) {
    if (busy) return;
    busy = true;
    if (btn) { btn.disabled = true; btn.textContent = cfg.recsAdding || '...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function () { busy = false; return refresh(); })
      .then(function () { return getJSON('/cart.js'); })
      .then(syncBubbles)
      .catch(function () { busy = false; if (btn) { btn.disabled = false; btn.textContent = cfg.recsAdd; } });
  }

  function syncBubbles(cart) {
    if (!cart) return;
    try {
      document.querySelectorAll('[data-cart-count], .cart-bubble__text, .hdb__count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (e) {}
  }

  // We handle add-to-cart ourselves so the theme's own add flow -- which drives a
  // view transition and was leaving the page frozen on a blank snapshot -- never runs.
  function interceptAddForms() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add/.test(action)) return;

        e.preventDefault();
        e.stopPropagation();

        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');

        var fd = new FormData(form);
        fd.delete('sections');
        fd.delete('sections_url');

        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (btn) btn.removeAttribute('aria-busy');
            if (cfg.autoOpen === false) { refresh(); } else { open(); }
            return getJSON('/cart.js').then(syncBubbles);
          })
          .catch(function () { if (btn) btn.removeAttribute('aria-busy'); });
      },
      true
    );
  }

  function bind() {
    root.addEventListener('click', function (e) {
      if (e.target.closest('.mcart__close') || e.target.classList.contains('mcart__scrim')) {
        e.preventDefault();
        close();
        return;
      }
      var qb = e.target.closest('.mcart__qbtn');
      if (qb) {
        e.preventDefault();
        var li = qb.closest('.mcart__item');
        if (!li) return;
        var val = parseInt(li.querySelector('.mcart__qval').textContent, 10) || 1;
        var next = qb.dataset.act === 'inc' ? val + 1 : val - 1;
        change(li.dataset.key, Math.max(0, next), li);
        return;
      }
      var ra = e.target.closest('.mcart__recadd');
      if (ra && ra.dataset.vid) {
        e.preventDefault();
        addVariant(ra.dataset.vid, ra);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest && e.target.closest('a, button');
        if (!t || root.contains(t)) return;

        if (t.hasAttribute('data-mcart-open')) {
          e.preventDefault();
          e.stopPropagation();
          open();
          return;
        }
        if (t.tagName === 'A') {
          var path = (t.pathname || '').replace(/\/$/, '');
          if (path === '/cart') {
            e.preventDefault();
            e.stopPropagation();
            open();
          }
        }
      },
      true
    );
  }

  function removeHorizonDrawer() {
    try {
      document.querySelectorAll('cart-drawer-component').forEach(function (el) {
        el.removeAttribute('auto-open');
        el.remove();
      });
    } catch (e) {}
  }

  function init() {
    removeHorizonDrawer();
    if (!cfgGet()) return;
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    skeleton();
    bind();
    interceptAddForms();
    window.MpmCart = { open: open, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    removeHorizonDrawer();
    root = null;
    init();
  });
})();
